import { DEFAULTS } from '@photo-sphere-viewer/core';

DEFAULTS.defaultPitch = -Math.PI / 2;

export { LittlePlanetAdapter } from './LittlePlanetAdapter';
